// // Hover behavior (desktop)
// document.querySelectorAll('.kg-hover-autoplay-video').forEach(container => {
//   container.addEventListener('mouseenter', () => {
//     const videos = container.querySelectorAll('video');
//     videos.forEach(video => {
//         if (video.paused) { // Only play if not already playing
//         console.log('Hover in: Starting video from the beginning');
//         video.currentTime = 0;
//         video.play().catch(err => {
//             console.warn('Hover play blocked:', err);
//         });
//         }
//     });
//   });

//   container.addEventListener('mouseleave', (e) => {
//     // Only pause/reset if the mouse is leaving to something outside container AND icon
//     const related = e.relatedTarget;
//     if (related && (container.contains(related) || related.closest('.kg-video-icon'))) {
//       return; // Still inside container or hovering icon → do nothing
//     }

//     const videos = container.querySelectorAll('video');
//     videos.forEach(video => {
//       console.log('Hover out: Pausing video and resetting');
//       video.pause();
//       video.currentTime = 0;
//     });
//   });
// });

// // Click behavior (mobile & desktop)
// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.kg-video-icon').forEach(icon => {
//     icon.addEventListener('click', () => {
//       const mainCardWrapper = icon.closest('.grid__item');
//       if (!mainCardWrapper) return;

//       const mediaContainer = mainCardWrapper.querySelector('.kg-hover-autoplay-video');
//       if (!mediaContainer) return;

//       const videos = mediaContainer.querySelectorAll('video');
//       videos.forEach(video => {
//         if (video.paused) {
//           console.log('Video icon clicked: Playing video from the beginning');
//           video.currentTime = 0;
//           video.play().catch(err => console.warn('Click play blocked:', err));
//         } else {
//           console.log('Video icon clicked: Pausing video');
//           video.pause();
//         }
//       });
//     });
//   });
// });

// Track which containers are currently being hovered to prevent duplicate triggers
const hoveredContainers = new WeakSet();

// Function to pause all videos except the one specified
function pauseAllOtherVideos(currentVideo) {
  document.querySelectorAll('.kg-hover-autoplay-video video').forEach(video => {
    if (video !== currentVideo && !video.paused) {
      video.pause();
      video.currentTime = 0;
    }
  });
}

document.addEventListener('mouseover', (e) => {
  const container = e.target.closest('.kg-hover-autoplay-video');
  if (!container) return;

  // Don't trigger if already hovering this container
  if (hoveredContainers.has(container)) return;

  // Don't trigger if hovering over video icon
  if (e.target.closest('.kg-video-icon')) return;

  // Mark container as hovered
  hoveredContainers.add(container);

  const videos = container.querySelectorAll('video');
  
  // Always pause videos in other containers when hovering a new container
  videos.forEach(video => {
    pauseAllOtherVideos(video);
  });
  
  videos.forEach(video => {
    if (video.paused) {
      // Ensure video is muted (required for autoplay in browsers)
      if (!video.muted) {
        video.muted = true;
      }
      
      // Ensure video is loaded before playing
      // readyState: 0=HAVE_NOTHING, 1=HAVE_METADATA, 2=HAVE_CURRENT_DATA, 3=HAVE_FUTURE_DATA, 4=HAVE_ENOUGH_DATA
      const playVideo = function() {
        // Pause all other videos before playing this one (double-check)
        pauseAllOtherVideos(video);
        video.currentTime = 0;
        video.play().catch(err => {
          console.warn('Hover play blocked:', err);
          // If play fails, try loading first
          if (video.readyState < 2) {
            video.load();
            video.addEventListener('canplay', () => {
              pauseAllOtherVideos(video);
              video.currentTime = 0;
              video.play().catch(e => console.warn('Retry play failed:', e));
            }, { once: true });
          }
        });
      };
      
      if (video.readyState < 2) {
        // Video not loaded yet, load it and wait for data
        video.load();
        video.addEventListener('loadeddata', playVideo, { once: true });
        // Fallback: try to play after a short delay if loadeddata doesn't fire
        setTimeout(() => {
          if (video.readyState >= 2 && video.paused) {
            playVideo();
          }
        }, 200);
      } else {
        console.log('Hover in: Starting video from the beginning');
        playVideo();
      }
    }
  });
});

document.addEventListener('mouseout', (e) => {
  const container = e.target.closest('.kg-hover-autoplay-video');
  if (!container) return;

  // Don't pause if moving to video icon or still within container
  const related = e.relatedTarget;
  if (related && (container.contains(related) || related.closest('.kg-video-icon'))) {
    return;
  }

  // Remove from hovered containers
  hoveredContainers.delete(container);

  const videos = container.querySelectorAll('video');
  videos.forEach(video => {
    console.log('Hover out: Pausing video and resetting');
    video.pause();
    video.currentTime = 0;
  });
});

// Video icon click handler - play/pause video
document.addEventListener('click', (e) => {
  const icon = e.target.closest('.kg-video-icon');
  if (!icon) return;

  // Stop event propagation to prevent video click handler from firing
  e.stopPropagation();
  e.preventDefault();

  const mainCardWrapper = icon.closest('.grid__item');
  if (!mainCardWrapper) return;

  const mediaContainer = mainCardWrapper.querySelector('.kg-hover-autoplay-video');
  if (!mediaContainer) return;

  const videos = mediaContainer.querySelectorAll('video');
  const isMobile = window.innerWidth <= 768;
  
  videos.forEach(video => {
    if (isMobile) {
      // On mobile, always play the video when icon is clicked
      console.log('Video icon clicked (mobile): Playing video from the beginning');
      video.currentTime = 0;
      video.play().catch(err => console.warn('Click play blocked:', err));
    } else {
      // On desktop, toggle play/pause
      if (video.paused) {
        console.log('Video icon clicked: Playing video from the beginning');
        video.currentTime = 0;
        video.play().catch(err => console.warn('Click play blocked:', err));
      } else {
        console.log('Video icon clicked: Pausing video');
        video.pause();
      }
    }
  });
});

// Card/video click handler - play video or redirect on mobile
document.addEventListener('click', (e) => {
  // Check if we're in mobile view (max-width: 768px based on CSS media query)
  const isMobile = window.innerWidth <= 768;
  if (!isMobile) return;

  // Don't handle if click originated from video icon (icon has its own handler)
  const icon = e.target.closest('.kg-video-icon');
  if (icon) return;

  // Find the card wrapper - check if click is on card, video, or card media
  const cardWrapper = e.target.closest('.kg-hover-autoplay-video');
  if (!cardWrapper) return;

  // Find the video element in this card
  const video = cardWrapper.querySelector('video');
  if (!video) return;

  // Prevent default link behavior
  e.preventDefault();
  e.stopPropagation();

  // Check if video is currently playing
  const isPlaying = !video.paused && !video.ended && video.currentTime > 0 && video.readyState > 2;

  if (isPlaying) {
    // Video is playing - redirect to product page
    let productLink = cardWrapper.querySelector('a.full-unstyled-link[id^="CardLink-"]');
    if (!productLink) {
      productLink = cardWrapper.querySelector('a.full-unstyled-link[id^="StandardCardNoMediaLink-"]');
    }
    if (!productLink) {
      // Fallback: find any full-unstyled-link in the card wrapper
      productLink = cardWrapper.querySelector('a.full-unstyled-link');
    }
    if (!productLink) {
      // Last fallback: try to find link in the grid item
      const gridItem = cardWrapper.closest('.grid__item');
      if (gridItem) {
        productLink = gridItem.querySelector('a.full-unstyled-link');
      }
    }

    if (productLink && productLink.href) {
      console.log('Video is playing - redirecting to product page');
      window.location.href = productLink.href;
    }
  } else {
    // Video is paused - play it from the beginning
    console.log('Video is paused - playing video from the beginning');
    video.currentTime = 0;
    video.play().catch(err => console.warn('Click play blocked:', err));
  }
});

// window.kgMasonryInstances = window.kgMasonryInstances || [];
// document.querySelectorAll('.kg-misonary-grid-item-list').forEach(function (grid) {
//   var msnry = new Masonry(grid, {
//     itemSelector: '.kg-misonary-grid-item',
//     columnWidth: '.kg-misonary-grid-item',
//     percentPosition: true
//   });
//   window.kgMasonryInstances.push(msnry);
// });

// window.kgRefreshMasonryFunction = function () {
//   if (window.kgMasonryInstances && window.kgMasonryInstances.length > 0) {
//     window.kgMasonryInstances.forEach(function (kgMasonryInstance) {
//       kgMasonryInstance.layout();
//     });
//   }
// }

// function throttle(fn, wait) {
//   let lastTime = 0;
//   return function (...args) {
//     const now = Date.now();
//     if (now - lastTime >= wait) {
//       lastTime = now;
//       fn.apply(this, args);
//     }
//   };
// }

// Function to initialize/rebind Masonry instances
window.kgInitializeMasonry = function() {
  // Destroy existing instances to prevent duplicates
  if (window.kgMasonryInstances && window.kgMasonryInstances.length > 0) {
    window.kgMasonryInstances.forEach(function(msnry) {
      if (msnry && msnry.destroy) {
        msnry.destroy();
      }
    });
    window.kgMasonryInstances = [];
  }

  // Initialize new Masonry instances
  window.kgMasonryInstances = window.kgMasonryInstances || [];
  document.querySelectorAll('.kg-misonary-grid-item-list').forEach(function (grid) {
    var msnry = new Masonry(grid, {
      itemSelector: '.kg-misonary-grid-item',
      columnWidth: '.kg-misonary-grid-item',
      percentPosition: true,
      // horizontalOrder: true,
      // fitWidth: true,
      gutter: 3
    });

    window.kgMasonryInstances.push(msnry);
  });
};

// Initialize on page load
window.kgInitializeMasonry();

// // refresh on resize (throttled)
// window.addEventListener('resize', throttle(function () {
//   window.kgMasonryInstances.forEach(msnry => msnry.layout());
// }, 150));
